import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisUnlicensedRoute: InvariantJiraRoute = {
	name: 'polaris-unlicensed',
	path: '/jira/polaris/unlicensed',
	exact: true,
};
